import logger from '3-foundation/Logging/logger';
import { mapFirstLink } from '../DataTypes/linkMapper';
import { getNews } from '3-foundation/News/repository';

interface Props {
	content: {
		properties: {
			title: string;
			newsDataSource: Umbraco.TreeNode[];
			quantity: number;
			filter: {
				name: string;
			}[];
			link: Umbraco.Link[];
		};
	};
	siteId: string;
	locale: string;
}

export const mapNewsList = async ({ content, siteId, locale }: Props): Promise<Content.NewsList> => {
	const { title, newsDataSource, quantity, filter, link } = content?.properties ?? {};
	try {
		const { items } = await getNews({
			filters: {
				parentId: newsDataSource[0].id,
				tagsSubject: filter?.length ? [filter?.[0]?.name] : null,
			},
			limit: quantity,
			siteId,
			locale,
		});
		return {
			documentType: 'newsList',
			content: {
				title: title || null,
				news: items || null,
				link: mapFirstLink(link),
			},
		};
	} catch (e) {
		logger.error(`Could not map NewsList \nCause: ${e}`);
		throw new Error(`Could not map NewsList \nCause: ${e}`, { cause: e });
	}
};
